/**
 * Tooltip — universal hint helper. Radix Tooltip с фирменными токенами.
 * Открывается по hover/focus, ESC закрывает.
 *
 * Usage:
 *   <Tooltip content="Email будет использован для входа">
 *     <button aria-label="Подсказка"><Icon name="info" size={16}/></button>
 *   </Tooltip>
 */
import * as RT from '@radix-ui/react-tooltip'
import { type ReactNode } from 'react'

export function Tooltip({
  content,
  children,
  side = 'top',
  delayDuration = 150,
}: {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  delayDuration?: number
}) {
  return (
    <RT.Provider delayDuration={delayDuration}>
      <RT.Root>
        <RT.Trigger asChild>{children}</RT.Trigger>
        <RT.Portal>
          <RT.Content
            side={side}
            sideOffset={6}
            className="z-50 max-w-xs rounded-md border border-border-strong bg-surface-raised text-text-primary text-xs px-2.5 py-1.5 shadow-lg
                       data-[state=delayed-open]:animate-in data-[state=closed]:animate-out
                       data-[state=delayed-open]:fade-in-0 data-[state=closed]:fade-out-0
                       data-[state=delayed-open]:zoom-in-95"
          >
            {content}
            <RT.Arrow className="fill-border-strong" width={10} height={5} />
          </RT.Content>
        </RT.Portal>
      </RT.Root>
    </RT.Provider>
  )
}
